import { useState } from 'react';
import { Link } from 'react-router-dom';

const countries = [
  { code: 'TR', name: 'Türkiye', flag: '🇹🇷' },
  { code: 'DE', name: 'Almanya', flag: '🇩🇪' },
  { code: 'US', name: 'Amerika Birleşik Devletleri', flag: '🇺🇸' },
  { code: 'GB', name: 'Birleşik Krallık', flag: '🇬🇧' },
  { code: 'FR', name: 'Fransa', flag: '🇫🇷' },
  { code: 'JP', name: 'Japonya', flag: '🇯🇵' },
  { code: 'KR', name: 'Güney Kore', flag: '🇰🇷' },
  { code: 'BR', name: 'Brezilya', flag: '🇧🇷' },
  { code: 'IT', name: 'İtalya', flag: '🇮🇹' },
  { code: 'ES', name: 'İspanya', flag: '🇪🇸' },
  { code: 'NL', name: 'Hollanda', flag: '🇳🇱' },
  { code: 'CA', name: 'Kanada', flag: '🇨🇦' },
  { code: 'AU', name: 'Avustralya', flag: '🇦🇺' },
  { code: 'RU', name: 'Rusya', flag: '🇷🇺' },
  { code: 'MX', name: 'Meksika', flag: '🇲🇽' },
];

const languages = [
  { code: 'tr', name: 'Türkçe', native: 'Türkçe' },
  { code: 'en', name: 'İngilizce', native: 'English' },
  { code: 'de', name: 'Almanca', native: 'Deutsch' },
  { code: 'fr', name: 'Fransızca', native: 'Français' },
  { code: 'es', name: 'İspanyolca', native: 'Español' },
  { code: 'pt', name: 'Portekizce', native: 'Português' },
  { code: 'ru', name: 'Rusça', native: 'Русский' },
  { code: 'ja', name: 'Japonca', native: '日本語' },
  { code: 'ko', name: 'Korece', native: '한국어' },
  { code: 'zh', name: 'Çince', native: '中文' },
  { code: 'ar', name: 'Arapça', native: 'العربية' },
  { code: 'it', name: 'İtalyanca', native: 'Italiano' },
];

const preferredCountryCandidates = [
  { code: 'TR', name: 'Türkiye', flag: '🇹🇷' },
  { code: 'DE', name: 'Almanya', flag: '🇩🇪' },
  { code: 'US', name: 'ABD', flag: '🇺🇸' },
  { code: 'GB', name: 'İngiltere', flag: '🇬🇧' },
  { code: 'FR', name: 'Fransa', flag: '🇫🇷' },
  { code: 'JP', name: 'Japonya', flag: '🇯🇵' },
];

const LocationLanguageSection = () => {
  const [myCountry, setMyCountry] = useState('TR');
  const [preferredCountries, setPreferredCountries] = useState<string[]>([]);
  const [uiLang, setUiLang] = useState('tr');
  const [chatLangs, setChatLangs] = useState<string[]>(['tr', 'en']);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const isPremium = false;

  const toggleChatLang = (code: string) => {
    setChatLangs((prev) =>
      prev.includes(code) ? prev.filter((x) => x !== code) : [...prev, code]
    );
  };

  const togglePreferredCountry = (code: string) => {
    setPreferredCountries((prev) =>
      prev.includes(code) ? prev.filter((x) => x !== code) : [...prev, code]
    );
  };

  const handleSave = () => {
    setSaving(true);
    setTimeout(() => { setSaving(false); setSaved(true); setTimeout(() => setSaved(false), 2500); }, 900);
  };

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-xl font-extrabold text-white mb-1">Konum & Dil</h2>
        <p className="text-white/40 text-sm">Ülke konumunu ve dil tercihlerini belirle.</p>
      </div>

      <div className="flex flex-col gap-6">
        {/* My country */}
        <div className="p-6 rounded-2xl bg-white/3 border border-white/8">
          <label className="block text-white/50 text-xs font-semibold uppercase tracking-widest mb-3">
            Bulunduğum Ülke
          </label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-lg pointer-events-none">
              {countries.find((c) => c.code === myCountry)?.flag}
            </span>
            <select
              value={myCountry}
              onChange={(e) => setMyCountry(e.target.value)}
              className="w-full pl-11 pr-4 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm focus:outline-none focus:border-cyan-500/50 transition-colors cursor-pointer appearance-none"
            >
              {countries.map((c) => (
                <option key={c.code} value={c.code}>{c.flag} {c.name}</option>
              ))}
            </select>
            <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-white/30 pointer-events-none" />
          </div>
          <p className="text-white/25 text-xs mt-2">Konumun diğer kullanıcılara yalnızca ülke düzeyinde gösterilir.</p>
        </div>

        {/* Preferred countries — premium locked */}
        <div className="p-6 rounded-2xl bg-white/3 border border-white/8 relative">
          {!isPremium && (
            <div className="absolute inset-0 rounded-2xl bg-black/50 backdrop-blur-[2px] z-10 flex flex-col items-center justify-center gap-3 px-6">
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-yellow-500/15 border border-yellow-500/30">
                <i className="ri-vip-crown-line text-yellow-400 text-sm" />
                <span className="text-yellow-400 text-sm font-bold whitespace-nowrap">Premium Özelliği</span>
              </div>
              <p className="text-white/50 text-xs text-center max-w-xs">Ülke filtresi yalnızca Premium üyelere açıktır. Belirli ülkelerden kullanıcılarla eşleş.</p>
              <Link to="/premium" className="px-5 py-2 rounded-full bg-gradient-to-r from-yellow-500 to-orange-500 text-black text-xs font-extrabold cursor-pointer whitespace-nowrap">
                Premium'a Geç
              </Link>
            </div>
          )}
          <label className="block text-white/50 text-xs font-semibold uppercase tracking-widest mb-4">
            Tercih Ettiğim Ülkeler
          </label>
          <div className="flex flex-wrap gap-2">
            {preferredCountryCandidates.map((c) => (
              <button
                key={c.code}
                onClick={() => isPremium && togglePreferredCountry(c.code)}
                className={`flex items-center gap-2 px-3 py-2 rounded-xl border text-sm transition-all cursor-pointer ${
                  preferredCountries.includes(c.code)
                    ? 'bg-violet-500/15 border-violet-500/35 text-violet-300'
                    : 'bg-white/4 border-white/10 text-white/50 hover:bg-white/7'
                }`}
              >
                <span className="text-base leading-none">{c.flag}</span>
                <span className="text-xs whitespace-nowrap">{c.name}</span>
              </button>
            ))}
          </div>
          {preferredCountries.length === 0 && (
            <p className="text-white/25 text-xs mt-3">Ülke seçilmedi — tüm ülkelerden eşleşme yapılır.</p>
          )}
        </div>

        {/* UI Language */}
        <div className="p-6 rounded-2xl bg-white/3 border border-white/8">
          <label className="block text-white/50 text-xs font-semibold uppercase tracking-widest mb-3">
            Arayüz Dili
          </label>
          <div className="relative">
            <i className="ri-translate-2 absolute left-4 top-1/2 -translate-y-1/2 text-white/30 text-sm pointer-events-none" />
            <select
              value={uiLang}
              onChange={(e) => setUiLang(e.target.value)}
              className="w-full pl-10 pr-4 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm focus:outline-none focus:border-cyan-500/50 transition-colors cursor-pointer appearance-none"
            >
              {languages.map((l) => (
                <option key={l.code} value={l.code}>{l.name} ({l.native})</option>
              ))}
            </select>
            <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-white/30 pointer-events-none" />
          </div>
        </div>

        {/* Chat languages */}
        <div className="p-6 rounded-2xl bg-white/3 border border-white/8">
          <label className="block text-white/50 text-xs font-semibold uppercase tracking-widest mb-2">
            Sohbet Dilleri
          </label>
          <p className="text-white/30 text-xs mb-4">Hangi dillerde sohbet etmek istiyorsun?</p>
          <div className="flex flex-wrap gap-2">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => toggleChatLang(lang.code)}
                className={`px-3 py-2 rounded-xl border text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                  chatLangs.includes(lang.code)
                    ? 'bg-cyan-500/15 border-cyan-500/35 text-cyan-400'
                    : 'bg-white/4 border-white/10 text-white/45 hover:bg-white/7 hover:text-white/65'
                }`}
              >
                {lang.name}
              </button>
            ))}
          </div>
          {chatLangs.length > 0 && (
            <p className="text-white/30 text-xs mt-3">
              Seçili: {chatLangs.map((c) => languages.find((l) => l.code === c)?.name).join(', ')}
            </p>
          )}
        </div>

        {/* Save */}
        <div>
          <button
            onClick={handleSave}
            disabled={saving}
            className="px-8 py-3.5 rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 text-white font-bold text-sm hover:from-cyan-400 hover:to-violet-500 transition-all cursor-pointer disabled:opacity-60 whitespace-nowrap shadow-lg shadow-cyan-500/20"
          >
            {saving ? (
              <span className="flex items-center gap-2"><i className="ri-loader-4-line animate-spin" /> Kaydediliyor...</span>
            ) : saved ? (
              <span className="flex items-center gap-2 text-emerald-300"><i className="ri-checkbox-circle-line" /> Kaydedildi!</span>
            ) : (
              <span className="flex items-center gap-2"><i className="ri-save-line" /> Kaydet</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationLanguageSection;
